// extracted by mini-css-extract-plugin
module.exports = {"block":"_2fq5Ce5Wo-nTstozeEhd38","blockInside":"y5i9HpgyPyVzimaaBnVaw","title":"_3JXMWpUYojUz4xRweA3L91","subtitle":"_3HbmqoinUkb9KpuJXU_teb"};